import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

// Toasts sit at the top: the default (bottom) put them on top of the fixed
// bottom nav, covering it for the toast's whole lifetime. The top offset
// clears the iOS notch / status bar inside the Capacitor WebView.
const TOP_OFFSET = { top: "calc(env(safe-area-inset-top) + 12px)" }

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="top-center"
      dir="rtl"
      offset={TOP_OFFSET}
      mobileOffset={TOP_OFFSET}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
